import React, { useEffect } from 'react';

import { logout } from '../../services/QueryToken/thunks';
import { useAppDispatch } from '../../store/hook';

function Logout() {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const timer = setTimeout(() => {
      logout(dispatch);
      window.location.href = process.env.REACT_APP_DJ_REDIRECT_URL;
    }, 2500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="flex items-center justify-center ">
      <div className="w-full max-w-2xl space-y-8 rounded-xl bg-white p-12 shadow-2xl">
        <div className="grid place-content-center">
          <img alt="Déclarations Juridiques Logo" src={require('../../../img/logo.svg')} className="mx-auto w-96" />
        </div>
        <div className="text-center">
          <h2 className="mt-6 text-4xl font-extrabold text-gray-900">Déconnexion</h2>
          <p className="mt-2 text-lg text-gray-600">Vous avez été déconnecté du module Croissance avec succès !</p>
        </div>
        <div className="mt-10 space-y-8">
          <div className="-space-y-px rounded-xl shadow-sm">
            <div className="bg-gray-50 px-6 py-6 sm:p-8">
              <div className="max-w-xl text-base text-gray-500">
                <p>
                  Redirection vers{' '}
                  <a href={process.env.REACT_APP_DJ_REDIRECT_URL} className="italic underline">Déclarations Juridiques</a>
                  {' '}
                  dans quelques secondes...
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Logout;
